import { Alert, Box, Flex, Text } from '@chakra-ui/react'

import { Cross, Tick, Warning } from '../components/Icons/default.jsx'

const AlertIcon = ({ status }) => {
    const commonStyles = { w: 8, h: 8, mr: { base: 3.5, md: 6 } }
    if (status === 'success') {
        return <Tick {...commonStyles} color={'fruitsalad'} />
    } else if (status === 'error') {
        return <Cross {...commonStyles} color={'flushmahogany'} />
    } else if (status === 'warning') {
        return <Warning {...commonStyles} />
    }
    return null
}

const Toast = ({ ...props }) => {
    delete props.render
    delete props.isClosable
    return (
        <Alert
            status={props.status}
            {...props}
            variant={{ base: 'retro-mobile', md: 'retro' }}
            w={{ md: '544px' }}
        >
            <Flex justify="space-between" w={'100%'}>
                <Box
                    display={'inline-flex'}
                    fontSize={'md'}
                    whiteSpace={'pre-wrap'}
                >
                    <AlertIcon status={props.status} />
                    <Text w={{ md: '347px' }}>{props.title}</Text>
                </Box>

                <Box cursor={'pointer'} onClick={props.onClose}>
                    <Text as={'i'}>
                        <Text as={'u'}>Dismiss</Text>
                    </Text>
                </Box>
            </Flex>
        </Alert>
    )
}

export default Toast
